import ProductsBlock from "@/themes/printerwebshop/ProductsBlock";
import { Dancing_Script } from "next/font/google";
import Head from "next/head";

const ds = Dancing_Script({
    weight: ["400", "500", "600", "700"], // amire szükség van
    subsets: ["latin"],
});

// <GoogleReviewsWidget vendorId={1} />

export default function Index({ products }) {

    return (
        <>
            <Head>
                <title>Printerwebshop.hu</title>
                {/* opcionális SEO */}
                <meta name="description" content="" />
            </Head>

            <ProductsBlock products={products} />

        </>
    );
}